export default __webpack_public_path__ + "static/education_training-6c6f5de83f4ccb47f28b9e6b7f443ee2.png";